import { create } from "zustand";

export const useSidebarStore = create((set) => ({
  isOpen: false,
  sidebarSize: "large", // 'large' or 'small'

  // Initialize sidebar size from localStorage
  initSidebarSize: () => {
    const storedSize = localStorage.getItem("sidebar-size") || "large";
    const body = document.getElementById("body");
    if (body) {
      body.classList.add(storedSize);
    }
    set({ sidebarSize: storedSize });
  },

  // show sidebar full size
  setSidebarSizeToLarge: () =>
    set(() => {
      const body = document.getElementById("body");

      if (body) {
        body.classList.remove('small');
        body.classList.add("large");
      }

      localStorage.setItem("sidebar-size", "large");
      return { sidebarSize: "large" };
    }),

  // Toggle sidebar size
  toggleSidebarSize: () =>
    set((state) => {
      const newSize = state.sidebarSize === "large" ? "small" : "large";
      const body = document.getElementById("body");

      if (body) {
        body.classList.remove(state.sidebarSize);
        body.classList.add(newSize);
      }

      localStorage.setItem("sidebar-size", newSize);
      return { sidebarSize: newSize };
    }),

  // Toggle sidebar visibility
  toggleSidebar: () =>
    set((state) => {
      const newIsOpen = !state.isOpen;
      const sidebar = document.getElementById("sidebar");

      if (sidebar) {
        if (newIsOpen) {
          document.body.classList.add("overflow-hidden");
          sidebar.classList.remove("hidden");
        } else {
          document.body.classList.remove("overflow-hidden");
          sidebar.classList.add("hidden");
        }
      }

      return { isOpen: newIsOpen };
    }),

  // Close sidebar
  closeSidebar: () =>
    set(() => {
      const sidebar = document.getElementById("sidebar");
      if (sidebar) {
        document.body.classList.remove("overflow-hidden");
        sidebar.classList.add("hidden");
      }
      return { isOpen: false };
    }),
}));
